// Sonido al mostrar al ganador. Las salas 90 a 93 no lo reproducen; la misma regla vale para todas las vistas
// de ganador (sorteo, Hot Seat, torneo y progresivo).
export const isWinnerSoundMuted = (salaId) => Number(salaId) >= 90 && Number(salaId) <= 93;
